import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storageSession from "redux-persist/lib/storage/session"; // for session storage
import { encryptTransform } from "redux-persist-transform-encrypt";
import rootReducer from "./reducers";
import rootSaga from "./sagas/index";

// Create a saga middleware instance
const sagaMiddleware = createSagaMiddleware();

// Create the persist config for session storage
const persistConfig = {
  key: "root",
  storage: storageSession,
  transforms: process.env.NODE_ENV === 'production' ? [
    encryptTransform({
      secretKey: "e56af8aae98a280599643993b621a0db",
      onError: (error) => {
        console.error("Encryption error:", error);
      },
    }),
  ] : null,
};

// Combine the root reducer with the persist config
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the Redux store with middleware and persisted reducer
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(sagaMiddleware),
  devTools: true,
});

// Run the root saga
sagaMiddleware.run(rootSaga);

// Create and export the persisted store
export const persistor = persistStore(store);
export default store;
